__turbopack_context__.v({
  "addEvBox": "CustomerInput-module__GnTNHa__addEvBox",
  "evDetail": "CustomerInput-module__GnTNHa__evDetail",
  "evDetails": "CustomerInput-module__GnTNHa__evDetails",
  "evNum": "CustomerInput-module__GnTNHa__evNum",
});
